import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgFlagCh = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      style={{
        shapeRendering: 'geometricPrecision',
        textRendering: 'geometricPrecision',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      }}
      viewBox="0 0 1000 1000"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        fill="red"
        d="M-.5-.5h1000v1000H-.5V-.5Z"
        style={{
          opacity: 1,
        }}
      />
      <path
        fill="#ffb1b0"
        d="M593.5 405.5a11879.716 11879.716 0 0 1-1-218h-186c.333 72.835-.001 145.502-1 218v-219h188v219Z"
        style={{
          opacity: 1,
        }}
      />
      <path
        fill="#fffefe"
        d="M593.5 405.5h218v187c-72.835-.333-145.502.001-218 1v218h-188v-218a11879.716 11879.716 0 0 0-218-1v-187h218c.999-72.498 1.333-145.165 1-218h186c-.333 72.835.001 145.502 1 218Z"
        style={{
          opacity: 1,
        }}
      />
      <path
        fill="#ffacab"
        d="M187.5 405.5v187c72.835-.333 145.502.001 218 1h-219a8840.16 8840.16 0 0 1 1-188ZM811.5 405.5a8840.16 8840.16 0 0 1 1 188h-219c72.498-.999 145.165-1.333 218-1v-187Z"
        style={{
          opacity: 1,
        }}
      />
    </SvgIcon>
  );
};
const Memo = memo(SvgFlagCh);
export default Memo;
